module Meevo.Plugins.Egifts {
    'use strict';

    import EGiftTemplateCatEnum = Meevo.Model.EGiftTemplateCatEnum;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    export class EgiftsBaseTemplate extends EgiftsBaseSection {
        public creatingNewTemplateControlsId: string = 'creating-new-template';
        public creatingNewTemplateClass: string = 'egifts__add-new-template-form';
        public templatesList: any;
        public templatesListDefault: any;
        public request: EgiftTemplates.IBaseTemplateReq | any = {
            criteria: undefined,
            asLocationId: 0
        };
        public changedItems: any = {
            templates: []
        };
        public newTemplate: any = this.emptyNewTemplateModel;
        public statusTypes: Array<EgiftTemplates.ICategoryStatusOption> = [
            { value: null, label: 'LABEL_ALL' },
            { value: ObjectStateEnum.Active, label: 'LABEL_ACTIVE' },
            { value: ObjectStateEnum.Inactive, label: 'LABEL_INACTIVE' },
        ];
        public templateEditStatus: TemplateEditStatus = TemplateEditStatus.None;

        constructor(params: ISectionParamsEgifts,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $q: angular.IQService) {

            super(params);
        }

        getData(isNotResetSearchOption?: boolean): void {
            if (!isNotResetSearchOption) {
                this.request.criteria.eGiftTemplateCategoryEnum = this.request.criteria.objectState = null;
            }

            let section = <any>this.context.selectedSection;
            let isCardTemplateSection = section instanceof CardTemplatesSection;

            if (!isCardTemplateSection) section.selectType();
            

            section.resetValues();

            let request: EgiftTemplates.IBaseTemplateReq = angular.copy(this.request);
            this.busyService.start();
            this.egiftsService.getTemplates(request, isCardTemplateSection).then((response: Array<ITemplateItem>) => {
                if (isCardTemplateSection) {
                    this.templatesList = response;
                    this.templatesListDefault = angular.copy(this.templatesList);
                    return;
                }
                _.each(response, template => {
                    section.addTemplateToDesiredCategory(template);
                });
                this.templatesListDefault = angular.copy(this.templatesList);
            }).finally(() => {
                this.busyService.stop();
            });
        }

        saveData(): any {
          if (!this.changedItems.templates.length) return this.$q.resolve(this.context.setMode(Meevo.Model.MaintenanceFormState.Readonly));
          if (!this.checkActiveTemplate()) {
              this.modalService.alert('MESSAGE_ACIVE_TEMPLATE_WARNING', Meevo.Components.Modal.ModalTranslationModes.Translate);
              return null;
          }

          this.context.loadingInProgress = true;
          return this.egiftsService.updateTemplates(this.changedItems, (<any>this.context.selectedSection).eGiftTemplateTypeEnum)
            .then((data: any) => {
              this.model = data;
              this.changedItems.templates = [];
              this.activate();
              this.context.setMode(Meevo.Model.MaintenanceFormState.Readonly);
              this.loggingService.trace(`Updates saved.`);
              this.getData(true);
            })
            .finally(() => {
              this.context.loadingInProgress = false;
              this.context.postUpdate(this.model);
            });  
        }

        filter(): void {
            let section = <any>this.context.selectedSection;
            section.resetValues();

            let request: EgiftTemplates.IBaseTemplateReq = angular.copy(this.request);
            request.criteria = {
                ...request.criteria,
                ...section.params
            }
            let isCardTemplateSection = section instanceof CardTemplatesSection;
            this.busyService.start();
            this.egiftsService.getTemplates(request, isCardTemplateSection).then((response: Array<ITemplateItem>) => {
                if (isCardTemplateSection) {
                    this.templatesList = response;
                    this.templatesListDefault = angular.copy(this.templatesList);
                    return;
                }
                _.each(response, template => {
                    section.addTemplateToDesiredCategory(template);
                });
                this.templatesListDefault = angular.copy(this.templatesList);
            }).finally(() => {
                this.busyService.stop();
            });
        }

        editTemplate(template: ITemplateItem): void {
            this.templateEditStatus = TemplateEditStatus.IsEditingExisting;
            this.context.edit();
            this.newTemplate = template;

            let section = <any>this.context.selectedSection;
            if (section instanceof TemplatesSection) {
                section.selectedCategoryForAddingNewTemplate = template.eGiftTemplateCatEnum;
            }
        }

        deleteTemplate(template: ITemplateItem): void {
            this.modalService.warning(
                'MESSAGE_DELETE_CONFIRMATION',
                Meevo.Components.Modal.ModalTranslationModes.Translate,
                false,
                {
                    showCancelButton: true,
                    cancelButtonContentKey: 'LABEL_NO',
                    cancelButtonHotKey: 'MODAL_NO_BUTTON',
                    okButtonHotKey: 'MODAL_YES_BUTTON',
                    okButtonContentKey: 'LABEL_YES'
                }
            ).then((result: boolean) => {
                if (result) this.saveEditedTemplate({ ...template, ...{ objectStateEnum: ObjectStateEnum.Deleted } });
            });
        }

        updateImageRevertTo() {
            this.newTemplate.fileGuid = null;
            this.newTemplate.templateMetaData = null;
            delete this.newTemplate.meevoFile.files;
        }

        rollbackTemplateChanges(): void {
            let section = <any>this.context.selectedSection;
            section.templateEditStatus = TemplateEditStatus.None;

            /*if (section instanceof CardTemplatesSection && $index) {
                this.templatesList[$index] = angular.copy(this.templatesListDefault[$index]);
                return;
            }*/
            this.templatesList = angular.copy(this.templatesListDefault);
        }

        closeEditTemplate(): any {
            return this.modalService.warning('MESSAGE_CLOSE_UNSAVED', Meevo.Components.Modal.ModalTranslationModes.Translate, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' }).then(() => {
                this.rollbackTemplateChanges();
            });
        }

        preSaveTemplate(template) {
            setTimeout(() => {this.saveIsEgift(template)}, 0)
        }

        saveIsEgift(templateListItem): void {
            let existedPackageItem: ITemplateItem = _.find(this.changedItems.templates, (item: any) => {
                if (item.id === templateListItem.id) {
                    item.objectStateEnum = templateListItem.objectStateEnum;
                    return item;
                }
            });

            if (!existedPackageItem) {
                this.changedItems.templates.push({
                    eGiftTemplateCatEnum: templateListItem.eGiftTemplateCatEnum,
                    //eGiftTemplateTypeEnum: templateListItem.eGiftTemplateTypeEnum,
                    id: templateListItem.id,
                    objectStateEnum: templateListItem.objectStateEnum,
                    templateName: templateListItem.templateName,
                    templateSupportsLogo: templateListItem.templateSupportsLogo
                });
            }
        }

        closeCreatingNewTemplate() {
            let section = <any>this.context.selectedSection;

            const emptyNewTemplateModel = this.emptyNewTemplateModel;
            // Check if user did not make any changes
            // If input return undefined for displayName change it to null throug _.defaults()
            // It happens when input has ng-required and after editing it's empty
            if (angular.equals(_.defaults(this.newTemplate, emptyNewTemplateModel), emptyNewTemplateModel)) {
                section.changeSelectedCategoryForAddingNewTemplate();
                return;
            }

            this.modalService.confirm('MESSAGE_CLOSE_UNSAVED', Meevo.Components.Modal.ModalTranslationModes.Translate).then(() => {
                section.changeSelectedCategoryForAddingNewTemplate();
            });
        }

        saveEditedTemplate(template: ITemplateItem): angular.IPromise<boolean> {
            let section = <any>this.context.selectedSection;
            let isCardTemplateSection = section instanceof CardTemplatesSection;

            if (!this.checkActiveTemplate()) {
                this.rollbackTemplateChanges();
                this.modalService.alert('MESSAGE_ACIVE_TEMPLATE_WARNING', Meevo.Components.Modal.ModalTranslationModes.Translate).then(() => false);
                return null;
            }

            if (!angular.isUndefined(template.meevoFile) && template.meevoFile.files) {
                template.templateMetaData = JSON.stringify({
                    fileGuid: template.meevoFile.fileGuid,
                    contentType: template.meevoFile.files[0].mimeType
                });
            }

            return this.egiftsService.createTemplate(template, isCardTemplateSection).then(() => {
                section.templateEditStatus = TemplateEditStatus.None;
                this.getData(true);

                return true;
            });
        }

        checkActiveTemplate(): boolean {
            let arr = [];
            if (<any>this.context.selectedSection instanceof TemplatesSection) {
                for (let a in this.templatesList) {
                    arr = [...arr, ...this.templatesList[a]];
                }
            } else {
                arr = this.templatesList;
            }

            return arr.some(el => el.objectStateEnum === ObjectStateEnum.Active);
        }

        protected getNewTemplate(categoryId: EGiftTemplateCatEnum): ITemplateItem {
            // Default value while creating
            this.newTemplate.eGiftTemplateTypeEnum = EGiftTemplateType.CustomTemplate;
            this.newTemplate.eGiftTemplateCatEnum = categoryId;
            if (!angular.isUndefined(this.newTemplate.meevoFile)) {
                this.newTemplate.templateMetaData = JSON.stringify({
                    fileGuid: this.newTemplate.meevoFile.fileGuid,
                    contentType: this.newTemplate.meevoFile.files[0].mimeType
                });
            }

            return this.newTemplate;
        }

        get emptyNewTemplateModel(): any {
            return {
                eGiftTemplateCatEnum: null,
                eGiftTemplateTypeEnum: null,
                id: null,
                objectStateEnum: ObjectStateEnum.Inactive,
                templateName: null,
                templateSupportsLogo: false
            };
        }

        get eGiftTemplateCategory(): any {
            return EGiftTemplateCatEnum;
        }

        get eGiftTemplateType(): any {
            return EGiftTemplateType;
        }

        get fileTypes(): any {
            return Meevo.Model.FileTypes;
        }

        get objectStateEnum(): any {
            return ObjectStateEnum;
        }
    }
}
